<template>
	<Page>
		<div class="centered">

			<div class="home_actions">

				<!-- <div class="actions">
					<router-link :to="{name:'template.new'}" class="btn-a" >New template</router-link>
				</div> -->

				<div class="search_box">
					<div class="search_inner">
						<input type="text" v-model="search_string" placeholder="Search" ref="searchbox" />
						<i class="fa fa-search"></i>
					</div>
				</div>
			
			</div>

			<div class="raised-box" >
				<List
					:loading="!(orgs_loaded && configs_loaded)"
					:results="sorted_filtered_configs"
					:columns="[
						{
							label:'Name',
							name:'name',
							rowClick:true,
							to : (v,t)=>({name:'config',params:{'config_id':t.id}})
						},
						{
							label:'Organisation',
							name:'org',
							text : (v,t)=>{
								var org = orgs.find((o)=>o.id==t.org_id);
								return org ? org.name||'Personal' : '??';
							},
						},
						{
							label:'Updated',
							name:'updated_at',
							text : (v,t)=>{
								return dsplDate(v);
							},
						},
					]"
				/>
			</div>

		</div>
	</Page>
</template>

<script>

	import Page from '../../mixins/Page';
	import List from '../../components/List';


	export default {
		mixins : [Page],
        components : {List},
        props:['template'],
		data() {
			return {
				search_string : '',
				orgs : [],
				configs : [],
				orgs_loaded : false,
				configs_loaded : false,
			};
		},
		mounted(){
			this.refreshList();
			this.$refs.searchbox.focus();
		},
		computed:{
			filtered_configs(){
				var self = this;
				var search_segments = self.search_string.toLowerCase().split(' ').filter(x=>x);
				if(!search_segments.length) return self.configs;
				
				return this.configs.filter((config)=>{
						
					var subject = [config.name].join(' ').toLowerCase();

					// Gauntlet style
					// Accumulator has to stay true throughout. Any failure along the way
					// turns it false 
					return search_segments.reduce((a,c)=>{
						if(!a) return a;
						return subject.includes(c);
					},true);
				});			
			},
			sorted_filtered_configs(){
				return this.filtered_configs.sort((a,b)=>{
					if(a.updated_at>b.updated_at) return -1;
					if(a.updated_at==b.updated_at) return 0;
					return 1;
				})	
			},
		},
		methods:{
			refreshList(){
				var self = this;

				api.list('config',{template_id:this.template.id},{sync_list:self.configs})
					.then((configs)=>{ self.configs_loaded = true })

				self.$store.dispatch('auth/refreshOrgs').then(function(orgs){
					self.orgs = orgs;
					self.orgs_loaded = true;
				});

			},
			dsplDate(mysql_string){
				var d = moment.utc(mysql_string);
				var since = moment.duration(moment().diff(d));
				var hours_since = since.asHours();
				if(hours_since < 24){
					return d.fromNow();
				} else {
					return d.format('DD/MM/YY');
				}
			}
		}
	}

</script>